const Flickity = require('flickity');
import 'flickity-as-nav-for';
const sliders = {

    init() {

        var sliderInit = $('.js-slider-init');
        var sliderMobileInit = $('.js-slider-mobile');
        var sliderTabletInit = $('.js-slider-tablet')

        var sliderMain = $('.js-slider-init-main');

        if(sliderMain[0]){
            Flickity.prototype.hasDragStarted = function( moveVector ) {
                // start dragging after pointer has moved 3 pixels in either direction
                return !this.isTouchScrolling && Math.abs( moveVector.x ) > 40;
            };
        }

        if(sliderInit[0]){

           $(sliderInit).each(function(index, el){
               var flky = new Flickity( el, {
                   // options
                   cellAlign:                          'left',
                   contain:                             true,
                   draggable: 							true,
                   // selectedAttraction: 				    0.02,
                   // friction: 							0.35,
                   accessibility: 						false,
                   prevNextButtons: 					false,
               });

               Flickity.prototype.hasDragStarted = function( moveVector ) {
                   // start dragging after pointer has moved 3 pixels in either direction
                   return !this.isTouchScrolling && Math.abs( moveVector.x ) > 40;
               };

               var selectedIndex = flky.selectedIndex;

               $('.next').on('click', function(){
                   flky.next();
                   // console.log(flky.cells.length)
                   console.log(selectedIndex)
                   $('.previous').removeClass('disabled');
                   if ( flky.selectedIndex == flky.cells.length ) {
                       $(this).addClass('disabled');
                   }else{
                       $(this).removeClass('disabled');
                   }
               });
               $('.previous').on('click', function(){
                   flky.previous();
                   if ( flky.selectedIndex == 0 ) {
                       $(this).addClass('disabled');
                   }else{

                   }
               });

               flky.on( 'settle', function() {
                   if ( flky.selectedIndex == flky.cells.length ) {

                       console.log('settled at new cell', flky.selectedIndex);
                       selectedIndex = flky.selectedIndex;

                   }
               });


           })

        }




        if(sliderMobileInit[0]){
            $(sliderMobileInit).each(function(index, el){

                var flick = new Flickity( el, {
                    watchCSS:                           true,
                    contain:                             true,
                    draggable: 							true,
                    selectedAttraction: 				 0.02,
                    friction: 							0.35,
                    accessibility: 						false,
                    prevNextButtons: 					false,
                    pageDots:                           false
                });

                Flickity.prototype.hasDragStarted = function( moveVector ) {
                    // start dragging after pointer has moved 3 pixels in either direction
                    return !this.isTouchScrolling && Math.abs( moveVector.x ) > 40;
                };

            })
        }

    }
}

export { sliders }